import { Path } from "d3-path";
export function withPath(shape) {
  var digits = 3;

  shape.digits = function (_) {
    if (!arguments.length) return digits;

    if (_ == null) {
      digits = null;
    } else {
      var d = Math.floor(_);
      if (!(d >= 0)) throw new RangeError("invalid digits: ".concat(_));
      digits = d;
    }

    return shape;
  };

  return function () {
    return new Path(digits);
  };
}